// ==================== JEE MAINS TESTS METADATA ====================
// Simple flat structure: 1 folder, 75-90 questions, flat answer key
export const freeJEETestsMetadata = {
  '2april2025mobile': {
    id: '2april2025mobile',
    testName: 'JEE-Main 2025: 2 April 2025 (Mobile Test) - English',
    year: '2025',
    examName: 'JEE-Main 2025',
    subject: '2 April 2025 (Mobile Test) - English',
    duration: 3 * 60 * 60,
    totalQuestions: 75,
    storagePath: 'PYQTestSeries/JeeMains/2 April 2025 Mobile',
    backLink: '/test-series/pyq/jeemains',
    answerKey: {
      1: "4", 2: "1", 3: "1", 4: "1", 5: "2", 6: "3", 7: "4", 8: "3", 9: "1", 10: "1",
    11: "1", 12: "2", 13: "4", 14: "2", 15: "4", 16: "2", 17: "4", 18: "1", 19: "2", 20: "3",
    21: "3", 22: "46", 23: "4", 24: "15", 25: "9", 26: "4", 27: "4", 28: "1", 29: "2", 30: "3",
    31: "1", 32: "4", 33: "4", 34: "2", 35: "2", 36: "3", 37: "3", 38: "2", 39: "1", 40: "3",
    41: "2", 42: "3", 43: "4", 44: "1", 45: "2", 46: "96500", 47: "189494", 48: "5", 49: "48", 50: "6",
    51: "3", 52: "3", 53: "3", 54: "3", 55: "1", 56: "1", 57: "4", 58: "2", 59: "4", 60: "4",
    61: "4", 62: "3", 63: "4", 64: "2", 65: "2", 66: "1", 67: "1", 68: "3", 69: "2", 70: "2",
    71: "309", 72: "9", 73: "40", 74: "1.5", 75: "2",
    }
  },
  '2sep2020shift1': {
    id: '2sep2020shift1',
    testName: 'JEE-Main 2020: 2 Sep 2020 (Shift1) - English',
    year: '2020',
    examName: 'JEE-Main 2020',
    subject: '2 Sep 2020 (Shift1) - English',
    duration: 3 * 60 * 60,
    totalQuestions: 75,
    storagePath: 'PYQTestSeries/JeeMains/2 Sep 2020 (Shift1)',
    backLink: '/test-series/pyq/jeemains',
    answerKey: {
      1: "4", 2: "1", 3: "1", 4: "1", 5: "2", 6: "3", 7: "4", 8: "3", 9: "1", 10: "1",
    11: "1", 12: "2", 13: "4", 14: "2", 15: "4", 16: "2", 17: "4", 18: "1", 19: "2", 20: "3",
    21: "3", 22: "46", 23: "4", 24: "15", 25: "9", 26: "4", 27: "4", 28: "1", 29: "2", 30: "3",
    31: "1", 32: "4", 33: "4", 34: "2", 35: "2", 36: "3", 37: "3", 38: "2", 39: "1", 40: "3",
    41: "2", 42: "3", 43: "4", 44: "1", 45: "2", 46: "96500", 47: "189494", 48: "5", 49: "48", 50: "6",
    51: "3", 52: "3", 53: "3", 54: "3", 55: "1", 56: "1", 57: "4", 58: "2", 59: "4", 60: "4",
    61: "4", 62: "3", 63: "4", 64: "2", 65: "2", 66: "1", 67: "1", 68: "3", 69: "2", 70: "2",
    71: "309", 72: "9", 73: "40", 74: "1.5", 75: "2",
    }
  },
  '3sep2020shift1': {
    id: '3sep2020shift1',
    testName: 'JEE-Main 2020: 3 Sep 2020 (Shift1) - English',
    year: '2020',
    examName: 'JEE-Main 2020',
    subject: '3 Sep 2020 (Shift1) - English',
    duration: 3 * 60 * 60,
    totalQuestions: 75,
    storagePath: 'PYQTestSeries/JeeMains/3 Sep 2020 (Shift1)',
    backLink: '/test-series/pyq/jeemains',
    answerKey: {1: "3", 2: "1", 3: "3", 4: "3", 5: "2", 6: "4", 7: "3", 8: "4", 9: "2", 10: "1",
    11: "2", 12: "3", 13: "2", 14: "4", 15: "1", 16: "2", 17: "4", 18: "3", 19: "3", 20: "2",
    21: "150", 22: "9", 23: "101", 24: "20", 25: "158", 26: "1", 27: "1", 28: "4", 29: "4", 30: "4",
    31: "4", 32: "1", 33: "4", 34: "1", 35: "3", 36: "1", 37: "2", 38: "4", 39: "1", 40: "4",
    41: "4", 42: "4", 43: "3", 44: "2", 45: "2", 46: "47", 47: "100", 48: "8", 49: "143", 50: "142",
    51: "1", 52: "4", 53: "1", 54: "3", 55: "3", 56: "3", 57: "4", 58: "2", 59: "2", 60: "3",
    61: "3", 62: "3", 63: "3", 64: "1", 65: "3", 66: "2", 67: "3", 68: "1", 69: "1", 70: "4",
    71: "4", 72: "4", 73: "3", 74: "8", 75: "10",
} 
  },
  '7jan2020shift1': {
    id: '7jan2020shift1',
    testName: 'JEE-Main 2020: 7 Jan 2020 (Shift1) - English',
    year: '2020',
    examName: 'JEE-Main 2020',
    subject: '7 Jan 2020 (Shift1) - English',
    duration: 3 * 60 * 60,
    totalQuestions: 75,
    storagePath: 'PYQTestSeries/JeeMains/7 Jan 2020 (Shift1)',
    backLink: '/test-series/pyq/jeemains',
    answerKey: {
      1: "2", 2: "4", 3: "1", 4: "3", 5: "2", 6: "1", 7: "2", 8: "4", 9: "4", 10: "1",
    11: "3", 12: "4", 13: "4", 14: "4", 15: "2", 16: "1", 17: "2", 18: "3", 19: "2", 20: "4",
    21: "10", 22: "60", 23: "600", 24: "175", 25: "11", 26: "3", 27: "2", 28: "3", 29: "4", 30: "4",
    31: "2", 32: "2", 33: "2", 34: "4", 35: "3", 36: "2", 37: "2", 38: "2", 39: "1", 40: "1",
    41: "2", 42: "2", 43: "4", 44: "2", 45: "3", 46: "-2.7", 47: "10.6", 48: "23.03", 49: "1.67", 50: "2",
    51: "2", 52: "4", 53: "4", 54: "4", 55: "2", 56: "3", 57: "2", 58: "3", 59: "1", 60: "1",
    61: "2", 62: "1", 63: "3", 64: "1", 65: "1", 66: "4", 67: "1", 68: "3", 69: "2", 70: "2",
    71: "30", 72: "5", 73: "36", 74: "18", 75: "3", 
     }
  },
  '8jan2020shift1': {
    id: '8jan2020shift1',
    testName: 'JEE-Main 2020: 8 Jan 2020 (Shift1) - English',
    year: '2020',
    examName: 'JEE-Main 2020',
    subject: '8 Jan 2020 (Shift1) - English',
    duration: 3 * 60 * 60,
    totalQuestions: 75,
    storagePath: 'PYQTestSeries/JeeMains/8 Jan 2020 (Shift1)',
    backLink: '/test-series/pyq/jeemains',
    answerKey: {1: "2", 2: "2", 3: "2", 4: "3", 5: "2", 6: "3", 7: "3", 8: "1", 9: "3", 10: "1",
    11: "2", 12: "3", 13: "4", 14: "1", 15: "1", 16: "2", 17: "4", 18: "1", 19: "4", 20: "4",
    21: "580", 22: "1", 23: "106", 24: "10", 25: "60", 26: "2", 27: "1", 28: "2", 29: "1", 30: "2",
    31: "2", 32: "3", 33: "3", 34: "1", 35: "2", 36: "3", 37: "1", 38: "1", 39: "2", 40: "4",
    41: "1", 42: "3", 43: "1", 44: "4", 45: "2", 46: "27", 47: "48", 48: "4.95", 49: "0.93", 50: "3",
    51: "1", 52: "2", 53: "3", 54: "2", 55: "1", 56: "2", 57: "4", 58: "2", 59: "1", 60: "3",
    61: "1", 62: "4", 63: "3", 64: "2", 65: "4", 66: "4", 67: "3", 68: "2", 69: "3", 70: "2",
    71: "8", 72: "490", 73: "1540", 74: "672", 75: "4",
}
  },
  // 2021 Tests
  '24feb2021shift1': {
    id: '24feb2021shift1',
    testName: 'JEE-Main 2021: 24 Feb 2021 (Shift1) - English',
    year: '2021',
    examName: 'JEE-Main 2021',
    subject: '24 Feb 2021 (Shift1) - English',
    duration: 3 * 60 * 60,
    totalQuestions: 75,
    storagePath: 'PYQTestSeries/JeeMains/24 Feb 2021 (Shift1)',
    backLink: '/test-series/pyq/jeemains',
    answerKey: {
      1: "3", 2: "1", 3: "3", 4: "1", 5: "4", 6: "1", 7: "3", 8: "2", 9: "1", 10: "1",
    11: "4", 12: "3", 13: "2", 14: "2", 15: "2", 16: "2", 17: "4", 18: "3", 19: "3", 20: "4",
    21: "25", 22: "25", 23: "1", 24: "25600", 25: "440", 26: "2000", 27: "15", 28: "75", 29: "25", 30: "25",
    31: "1", 32: "3", 33: "4", 34: "4", 35: "3", 36: "1", 37: "1", 38: "3", 39: "1", 40: "4",
    41: "1", 42: "4", 43: "1", 44: "2", 45: "1", 46: "3", 47: "4", 48: "1", 49: "2", 50: "3",
    51: "2", 52: "2", 53: "1380", 54: "1", 55: "5", 56: "12", 57: "2", 58: "8", 59: "36", 60: "26",
    61: "4", 62: "2", 63: "2", 64: "3", 65: "4", 66: "2", 67: "4", 68: "4", 69: "1", 70: "2",
    71: "4", 72: "1", 73: "2", 74: "4", 75: "2", 76: "3", 77: "2", 78: "3", 79: "1", 80: "4",
    81: "10", 82: "3", 83: "5", 84: "17", 85: "540", 86: "1", 87: "9", 88: "3", 89: "75", 90: "6",
    }
  },
  '25feb2021shift1': {
    id: '25feb2021shift1',
    testName: 'JEE-Main 2021: 25 Feb 2021 (Shift1) - English',
    year: '2021',
    examName: 'JEE-Main 2021',
    subject: '25 Feb 2021 (Shift1) - English',
    duration: 3 * 60 * 60,
    totalQuestions: 75,
    storagePath: 'PYQTestSeries/JeeMains/25 Feb 2021 (Shift1)',
    backLink: '/test-series/pyq/jeemains',
    answerKey: {
      1: "1", 2: "1", 3: "2", 4: "2", 5: "3", 6: "4", 7: "3", 8: "3", 9: "1", 10: "1",
    11: "1", 12: "3", 13: "2", 14: "4", 15: "3", 16: "3", 17: "2", 18: "4", 19: "2", 20: "2",
    21: "5", 22: "1", 23: "50", 24: "3600", 25: "1", 26: "128", 27: "1", 28: "144", 29: "10", 30: "15",
    31: "1", 32: "3", 33: "4", 34: "1", 35: "1", 36: "1", 37: "2", 38: "4", 39: "1", 40: "2",
    41: "1", 42: "2", 43: "4", 44: "1", 45: "1", 46: "2", 47: "1", 48: "1", 49: "1", 50: "3",
    51: "70", 52: "741", 53: "5576", 54: "4", 55: "173", 56: "4", 57: "7", 58: "375", 59: "526", 60: "1",
    61: "3", 62: "3", 63: "2", 64: "3", 65: "3", 66: "1", 67: "3", 68: "2", 69: "4", 70: "2",
    71: "4", 72: "2", 73: "3", 74: "3", 75: "4", 76: "4", 77: "1", 78: "3", 79: "4", 80: "3",
    81: "32", 82: "9", 83: "2", 84: "13", 85: "7", 86: "21", 87: "2", 88: "144", 89: "64", 90: "12",
    }
  },
  '16march2021shift1': {
    id: '16march2021shift1',
    testName: 'JEE-Main 2021: 16 March 2021 (Shift1) - English',
    year: '2021',
    examName: 'JEE-Main 2021',
    subject: '16 March 2021 (Shift1) - English',
    duration: 3 * 60 * 60,
    totalQuestions: 75,
    storagePath: 'PYQTestSeries/JeeMains/16 March 2021 (Shift1)',
    backLink: '/test-series/pyq/jeemains',
    answerKey: {
      1: "1", 2: "4", 3: "2", 4: "3", 5: "3", 6: "1", 7: "1", 8: "3", 9: "4", 10: "4",
    11: "3", 12: "1", 13: "3", 14: "3", 15: "3", 16: "1", 17: "1", 18: "1", 19: "4", 20: "4",
    21: "5", 22: "82", 23: "20", 24: "30", 25: "3", 26: "4", 27: "600", 28: "15", 29: "5", 30: "0",
    31: "4", 32: "2", 33: "4", 34: "2", 35: "2", 36: "2", 37: "4", 38: "3", 39: "2", 40: "4",
    41: "2", 42: "3", 43: "1", 44: "3", 45: "4", 46: "2", 47: "3", 48: "3", 49: "2", 50: "2",
    51: "3", 52: "9", 53: "9", 54: "20", 55: "50", 56: "16", 57: "33", 58: "106", 59: "10", 60: "2",
    61: "2", 62: "2", 63: "1", 64: "3", 65: "2", 66: "4", 67: "4", 68: "4", 69: "4", 70: "3",
    71: "3", 72: "2", 73: "2", 74: "2", 75: "4", 76: "1", 77: "4", 78: "2", 79: "3", 80: "3",
    81: "4", 82: "3", 83: "1", 84: "4", 85: "36", 86: "766", 87: "1", 88: "406", 89: "16", 90: "2",
    }
  },
  '17march2021shift1': {
    id: '17march2021shift1',
    testName: 'JEE-Main 2021: 17 March 2021 (Shift1) - English',
    year: '2021',
    examName: 'JEE-Main 2021',
    subject: '17 March 2021 (Shift1) - English',
    duration: 3 * 60 * 60,
    totalQuestions: 75,
    storagePath: 'PYQTestSeries/JeeMains/17 March 2021 (Shift1)',
    backLink: '/test-series/pyq/jeemains',
    answerKey: {1: "3", 2: "2", 3: "2", 4: "1", 5: "4", 6: "1", 7: "1", 8: "4", 9: "1", 10: "2",
    11: "3", 12: "2", 13: "1", 14: "2", 15: "4", 16: "2", 17: "2", 18: "2", 19: "2", 20: "2",
    21: "21", 22: "728", 23: "4", 24: "64", 25: "2", 26: "2", 27: "864", 28: "4", 29: "25", 30: "1206",
    31: "3", 32: "3", 33: "2", 34: "3", 35: "2", 36: "1", 37: "4", 38: "3", 39: "4", 40: "2",
    41: "1", 42: "1", 43: "1", 44: "1", 45: "4", 46: "2", 47: "2", 48: "4", 49: "3", 50: "4",
    51: "80", 52: "64", 53: "0", 54: "150", 55: "230", 56: "2", 57: "24", 58: "1389", 59: "2", 60: "4",
    61: "1", 62: "2", 63: "3", 64: "1", 65: "2", 66: "1", 67: "2", 68: "4", 69: "1", 70: "4",
    71: "3", 72: "4", 73: "1", 74: "1", 75: "3", 76: "4", 77: "1", 78: "1", 79: "4", 80: "2",
    81: "4", 82: "1", 83: "16", 84: "6", 85: "481", 86: "904", 87: "1", 88: "2", 89: "4", 90: "6",
}
  },
  '20july2021shift1': {
    id: '20july2021shift1',
    testName: 'JEE-Main 2021: 20 July 2021 (Shift1) - English',
    year: '2021',
    examName: 'JEE-Main 2021',
    subject: '20 July 2021 (Shift1) - English',
    duration: 3 * 60 * 60,
    totalQuestions: 75,
    storagePath: 'PYQTestSeries/JeeMains/20 July 2021 (Shift1)',
    backLink: '/test-series/pyq/jeemains',
    answerKey: {1: "4", 2: "4", 3: "1", 4: "2", 5: "1", 6: "1", 7: "4", 8: "4", 9: "4", 10: "2",
    11: "3", 12: "3", 13: "2", 14: "3", 15: "3", 16: "4", 17: "4", 18: "4", 19: "4", 20: "1",
    21: "1", 22: "1", 23: "4", 24: "2", 25: "100", 26: "2", 27: "132", 28: "3", 29: "25", 30: "40",
    31: "3", 32: "2", 33: "1", 34: "4", 35: "4", 36: "3", 37: "4", 38: "4", 39: "2", 40: "1",
    41: "2", 42: "1", 43: "2", 44: "3", 45: "3", 46: "3", 47: "3", 48: "1", 49: "4", 50: "1",
    51: "0", 52: "3", 53: "667", 54: "172", 55: "226", 56: "78", 57: "106", 58: "2", 59: "2", 60: "3",
    61: "3", 62: "2", 63: "2", 64: "2", 65: "1", 66: "2", 67: "1", 68: "3", 69: "1", 70: "4",
    71: "3", 72: "2", 73: "4", 74: "1", 75: "2", 76: "3", 77: "1", 78: "2", 79: "4", 80: "2",
    81: "777", 82: "21", 83: "34", 84: "3", 85: "910", 86: "1", 87: "1.25", 88: "4", 89: "81", 90: "6",
}
  },
  '22july2021shift1': {
    id: '22july2021shift1',
    testName: 'JEE-Main 2021: 22 July 2021 (Shift1) - English',
    year: '2021',
    examName: 'JEE-Main 2021',
    subject: '22 July 2021 (Shift1) - English',
    duration: 3 * 60 * 60,
    totalQuestions: 75,
    storagePath: 'PYQTestSeries/JeeMains/22 July 2021 (Shift1)',
    backLink: '/test-series/pyq/jeemains',
    answerKey: {1: "4", 2: "2", 3: "4", 4: "2", 5: "1", 6: "4", 7: "3", 8: "4", 9: "4", 10: "4",
    11: "1", 12: "2", 13: "3", 14: "1", 15: "1", 16: "4", 17: "3", 18: "4", 19: "1", 20: "1",
    21: "3", 22: "1", 23: "2", 24: "2", 25: "5", 26: "57", 27: "4", 28: "15", 29: "60", 30: "500",
    31: "2", 32: "3", 33: "1", 34: "2", 35: "4", 36: "4", 37: "3", 38: "1", 39: "4", 40: "1",
    41: "2", 42: "1", 43: "1", 44: "2", 45: "1", 46: "1", 47: "1", 48: "3", 49: "2", 50: "4",
    51: "78", 52: "12", 53: "21", 54: "2", 55: "6", 56: "106", 57: "4", 58: "3", 59: "7", 60: "1",
    61: "2", 62: "1", 63: "3", 64: "4", 65: "1", 66: "4", 67: "4", 68: "3", 69: "4", 70: "4",
    71: "1", 72: "1", 73: "3", 74: "1", 75: "3", 76: "1", 77: "4", 78: "2", 79: "1", 80: "4",
    81: "96", 82: "1251", 83: "8", 84: "96", 85: "4", 86: "3125", 87: "720", 88: "4", 89: "2", 90: "4",
}
  },
  '26aug2021shift2': {
    id: '26aug2021shift2',
    testName: 'JEE-Main 2021: 26 Aug 2021 (Shift2) - English',
    year: '2021',
    examName: 'JEE-Main 2021',
    subject: '26 Aug 2021 (Shift2) - English',
    duration: 3 * 60 * 60,
    totalQuestions: 75,
    storagePath: 'PYQTestSeries/JeeMains/26 Aug 2021 (Shift2)',
    backLink: '/test-series/pyq/jeemains',
    answerKey: {1: "1", 2: "2", 3: "2", 4: "1", 5: "1", 6: "1", 7: "4", 8: "4", 9: "3", 10: "3",
    11: "1", 12: "1", 13: "3", 14: "3", 15: "4", 16: "2", 17: "2", 18: "3", 19: "3", 20: "3",
    21: "14", 22: "15", 23: "2", 24: "7", 25: "543", 26: "3", 27: "60", 28: "50", 29: "30", 30: "130",
    31: "2", 32: "2", 33: "2", 34: "2", 35: "2", 36: "1", 37: "2", 38: "1", 39: "3", 40: "1",
    41: "2", 42: "1", 43: "1", 44: "2", 45: "3", 46: "4", 47: "4", 48: "1", 49: "2", 50: "2",
    51: "50", 52: "38", 53: "182", 54: "42", 55: "50", 56: "3", 57: "269", 58: "109", 59: "5", 60: "5",
    61: "4", 62: "1", 63: "2", 64: "4", 65: "4", 66: "1", 67: "4", 68: "4", 69: "1", 70: "4",
    71: "3", 72: "1", 73: "1", 74: "3", 75: "4", 76: "1", 77: "2", 78: "1", 79: "1", 80: "1",
    81: "18", 82: "6", 83: "7744", 84: "2021", 85: "49", 86: "12", 87: "4", 88: "114", 89: "5", 90: "96",
}
  },
  '27aug2021shift2': {
    id: '27aug2021shift2',
    testName: 'JEE-Main 2021: 27 Aug 2021 (Shift2) - English',
    year: '2021',
    examName: 'JEE-Main 2021',
    subject: '27 Aug 2021 (Shift2) - English',
    duration: 3 * 60 * 60,
    totalQuestions: 75,
    storagePath: 'PYQTestSeries/JeeMains/27 Aug 2021 (Shift2)',
    backLink: '/test-series/pyq/jeemains',
    answerKey: {1: "3", 2: "1", 3: "4", 4: "1", 5: "4", 6: "3", 7: "3", 8: "3", 9: "3", 10: "1",
    11: "4", 12: "2", 13: "1", 14: "4", 15: "2", 16: "4", 17: "3", 18: "3", 19: "3", 20: "1",
    21: "400", 22: "40", 23: "500", 24: "1", 25: "34", 26: "9", 27: "1", 28: "2", 29: "15", 30: "20",
    31: "1", 32: "2", 33: "1", 34: "4", 35: "1", 36: "4", 37: "3", 38: "4", 39: "1", 40: "4",
    41: "4", 42: "3", 43: "1", 44: "2", 45: "1", 46: "4", 47: "3", 48: "2", 49: "1", 50: "2",
    51: "19", 52: "50", 53: "3", 54: "84", 55: "964", 56: "6", 57: "271", 58: "760", 59: "16", 60: "2",
    61: "2", 62: "1", 63: "3", 64: "4", 65: "1", 66: "3", 67: "3", 68: "1", 69: "1", 70: "1",
    71: "3", 72: "3", 73: "2", 74: "3", 75: "3", 76: "2", 77: "2", 78: "4", 79: "2", 80: "3",
    81: "6", 82: "80", 83: "15", 84: "56", 85: "40", 86: "2", 87: "25", 88: "7", 89: "72", 90: "30",
}
  },
  // 2022 Tests
  '24june2022shift1': {
    id: '24june2022shift1',
    testName: 'JEE-Main 2022: 24 June 2022 (Shift1) - English',
    year: '2022',
    examName: 'JEE-Main 2022',
    subject: '24 June 2022 (Shift1) - English',
    duration: 3 * 60 * 60,
    totalQuestions: 90,
    storagePath: 'PYQTestSeries/JeeMains/24 June 2022 (Shift1)',
    backLink: '/test-series/pyq/jeemains',
    answerKey: {1: "4", 2: "4", 3: "3", 4: "1", 5: "1", 6: "2", 7: "2", 8: "2", 9: "2", 10: "1",
    11: "2", 12: "4", 13: "3", 14: "1", 15: "3", 16: "1", 17: "3", 18: "3", 19: "4", 20: "3",
    21: "3", 22: "120", 23: "6", 24: "12", 25: "25", 26: "242", 27: "10", 28: "3", 29: "2", 30: "750",
    31: "3", 32: "2", 33: "1", 34: "4", 35: "1", 36: "3", 37: "3", 38: "2", 39: "3", 40: "2",
    41: "2", 42: "1", 43: "2", 44: "2", 45: "3", 46: "4", 47: "4", 48: "2", 49: "1", 50: "2",
    51: "747", 52: "63", 53: "3", 54: "2", 55: "43", 56: "54", 57: "5", 58: "154", 59: "0", 60: "7",
    61: "3", 62: "4", 63: "3", 64: "4", 65: "4", 66: "1", 67: "4", 68: "2", 69: "2", 70: "2",
    71: "1", 72: "1", 73: "3", 74: "4", 75: "2", 76: "1", 77: "2", 78: "2", 79: "3", 80: "1",
    81: "40", 82: "8", 83: "2929", 84: "31", 85: "7", 86: "1", 87: "34", 88: "19", 89: "84", 90: "2",
}
  },
  '25june2022shift1': {
    id: '25june2022shift1',
    testName: 'JEE-Main 2022: 25 June 2022 (Shift1) - English',
    year: '2022',
    examName: 'JEE-Main 2022',
    subject: '25 June 2022 (Shift1) - English',
    duration: 3 * 60 * 60,
    totalQuestions: 90,
    storagePath: 'PYQTestSeries/JeeMains/25 June 2022 (Shift1)',
    backLink: '/test-series/pyq/jeemains',
    answerKey: {1: "1", 2: "3", 3: "2", 4: "1", 5: "4", 6: "2", 7: "3", 8: "3", 9: "2", 10: "1",
    11: "1", 12: "2", 13: "3", 14: "4", 15: "3", 16: "2", 17: "1", 18: "4", 19: "4", 20: "2",
    21: "2", 22: "2", 23: "600", 24: "100", 25: "31", 26: "80", 27: "6", 28: "450", 29: "2", 30: "4",
    31: "4", 32: "3", 33: "3", 34: "1", 35: "2", 36: "2", 37: "3", 38: "2", 39: "2", 40: "2",
    41: "1", 42: "1", 43: "1", 44: "3", 45: "4", 46: "3", 47: "3", 48: "3", 49: "4", 50: "2",
    51: "5418", 52: "20", 53: "1143", 54: "4", 55: "300", 56: "710", 57: "1", 58: "23", 59: "1", 60: "766",
    61: "1", 62: "4", 63: "2", 64: "1", 65: "4", 66: "1", 67: "3", 68: "3", 69: "1", 70: "2",
    71: "2", 72: "2", 73: "2", 74: "2", 75: "2", 76: "2", 77: "4", 78: "2", 79: "2", 80: "3",
    81: "4", 82: "64", 83: "98", 84: "286", 85: "4", 86: "7", 87: "414", 88: "2", 89: "576", 90: "5",
}
  },
  '25july2022shift1': {
    id: '25july2022shift1',
    testName: 'JEE-Main 2022: 25 July 2022 (Shift1) - English',
    year: '2022',
    examName: 'JEE-Main 2022',
    subject: '25 July 2022 (Shift1) - English',
    duration: 3 * 60 * 60,
    totalQuestions: 90,
    storagePath: 'PYQTestSeries/JeeMains/25 July 2022 (Shift1)',
    backLink: '/test-series/pyq/jeemains',
    answerKey: {1: "2", 2: "1", 3: "1", 4: "2", 5: "4", 6: "2", 7: "2", 8: "1", 9: "1", 10: "1",
    11: "2", 12: "2", 13: "4", 14: "3", 15: "2", 16: "1", 17: "1", 18: "3", 19: "1", 20: "1",
    21: "3", 22: "3", 23: "5", 24: "60", 25: "20", 26: "45", 27: "4", 28: "4", 29: "3", 30: "150",
    31: "3", 32: "3", 33: "3", 34: "3", 35: "1", 36: "1", 37: "3", 38: "2", 39: "4", 40: "3",
    41: "3", 42: "2", 43: "2", 44: "2", 45: "3", 46: "3", 47: "3", 48: "2", 49: "1", 50: "1",
    51: "2", 52: "22", 53: "104", 54: "56", 55: "1", 56: "4", 57: "1", 58: "5", 59: "0", 60: "2",
    61: "4", 62: "4", 63: "3", 64: "3", 65: "3", 66: "3", 67: "4", 68: "1", 69: "2", 70: "2",
    71: "2", 72: "1", 73: "1", 74: "2", 75: "2", 76: "1", 77: "3", 78: "3", 79: "3", 80: "1",
    81: "38", 82: "1492", 83: "27560", 84: "6006", 85: "10", 86: "2", 87: "17", 88: "3", 89: "5", 90: "3",
}
  },
  '26july2022shift1': {
    id: '26july2022shift1',
    testName: 'JEE-Main 2022: 26 July 2022 (Shift1) - English',
    year: '2022',
    examName: 'JEE-Main 2022',
    subject: '26 July 2022 (Shift1) - English',
    duration: 3 * 60 * 60,
    totalQuestions: 90,
    storagePath: 'PYQTestSeries/JeeMains/26 July 2022 (Shift1)',
    backLink: '/test-series/pyq/jeemains',
    answerKey: {1: "3", 2: "1", 3: "3", 4: "2", 5: "1", 6: "3", 7: "2", 8: "3", 9: "2", 10: "1",
    11: "1", 12: "2", 13: "2", 14: "2", 15: "3", 16: "2", 17: "2", 18: "3", 19: "2", 20: "2",
    21: "2", 22: "5", 23: "5", 24: "200", 25: "60", 26: "20", 27: "44", 28: "10", 29: "5", 30: "9",
    31: "4", 32: "3", 33: "3", 34: "1", 35: "2", 36: "2", 37: "4", 38: "3", 39: "2", 40: "3",
    41: "3", 42: "2", 43: "1", 44: "1", 45: "3", 46: "2", 47: "3", 48: "4", 49: "4", 50: "1",
    51: "24", 52: "54", 53: "1758", 54: "2", 55: "200", 56: "2", 57: "6", 58: "3", 59: "2", 60: "0",
    61: "4", 62: "3", 63: "3", 64: "2", 65: "4", 66: "4", 67: "2", 68: "4", 69: "2", 70: "2",
    71: "1", 72: "4", 73: "3", 74: "3", 75: "2", 76: "1", 77: "4", 78: "1", 79: "3", 80: "2",
    81: "272", 82: "180", 83: "6993", 84: "23", 85: "3", 86: "3", 87: "45", 88: "24", 89: "6", 90: "153",
}
  },
  // 2023 Tests
  '24jan2023shift2': {
    id: '24jan2023shift2',
    testName: 'JEE-Main 2023: 24 Jan 2023 (Shift2) - English',
    year: '2023',
    examName: 'JEE-Main 2023',
    subject: '24 Jan 2023 (Shift2) - English',
    duration: 3 * 60 * 60,
    totalQuestions: 90,
    storagePath: 'PYQTestSeries/JeeMains/24 Jan 2023 (Shift2)',
    backLink: '/test-series/pyq/jeemains',
    answerKey: {1: "2", 2: "1", 3: "3", 4: "3", 5: "3", 6: "4", 7: "3", 8: "1", 9: "4", 10: "3",
    11: "2", 12: "1", 13: "2", 14: "3", 15: "3", 16: "2", 17: "2", 18: "4", 19: "2", 20: "1",
    21: "100", 22: "32", 23: "7", 24: "1", 25: "105", 26: "44", 27: "9", 28: "3", 29: "54", 30: "6",
    31: "1", 32: "2", 33: "3", 34: "3", 35: "2", 36: "4", 37: "1", 38: "3", 39: "3", 40: "2",
    41: "2", 42: "4", 43: "4", 44: "1", 45: "3", 46: "1", 47: "3", 48: "3", 49: "2", 50: "4",
    51: "2", 52: "8", 53: "2", 54: "620", 55: "85", 56: "314", 57: "5", 58: "2", 59: "3", 60: "8",
    61: "2", 62: "3", 63: "2", 64: "3", 65: "4", 66: "2", 67: "1", 68: "3", 69: "2", 70: "2",
    71: "1", 72: "3", 73: "4", 74: "3", 75: "3", 76: "4", 77: "3", 78: "3", 79: "4", 80: "4",
    81: "5", 82: "405", 83: "2", 84: "123", 85: "13", 86: "27", 87: "36", 88: "8", 89: "384", 90: "432" 
}
  },
  '25jan2023shift2': {
    id: '25jan2023shift2',
    testName: 'JEE-Main 2023: 25 Jan 2023 (Shift2) - English',
    year: '2023',
    examName: 'JEE-Main 2023',
    subject: '25 Jan 2023 (Shift2) - English',
    duration: 3 * 60 * 60,
    totalQuestions: 90,
    storagePath: 'PYQTestSeries/JeeMains/25 Jan 2023 (Shift2)',
    backLink: '/test-series/pyq/jeemains',
    answerKey: {1: "2", 2: "1", 3: "4", 4: "1", 5: "3", 6: "1", 7: "4", 8: "2", 9: "2", 10: "4",
    11: "1", 12: "1", 13: "2", 14: "2", 15: "4", 16: "1", 17: "1", 18: "4", 19: "4", 20: "4",
    21: "2", 22: "4", 23: "5", 24: "1", 25: "400", 26: "6", 27: "1", 28: "68", 29: "8", 30: "30",
    31: "2", 32: "2", 33: "4", 34: "3", 35: "3", 36: "1", 37: "2", 38: "4", 39: "3", 40: "3",
    41: "2", 42: "3", 43: "2", 44: "2", 45: "1", 46: "2", 47: "1", 48: "4", 49: "2", 50: "4",
    51: "12", 52: "5", 53: "847", 54: "4", 55: "3", 56: "1", 57: "2", 58: "2", 59: "5", 60: "3",
    61: "4", 62: "4", 63: "2", 64: "3", 65: "3", 66: "3", 67: "1", 68: "4", 69: "1", 70: "4",
    71: "4", 72: "3", 73: "4", 74: "2", 75: "1", 76: "1", 77: "2", 78: "1", 79: "3", 80: "2",
    81: "45", 82: "6860", 83: "3", 84: "7", 85: "25", 86: "31", 87: "3", 88: "20", 89: "18", 90: "9" 
}
  },
  '6april2023shift1': {
    id: '6april2023shift1',
    testName: 'JEE-Main 2023: 6 April 2023 (Shift1) - English',
    year: '2023',
    examName: 'JEE-Main 2023',
    subject: '6 April 2023 (Shift1) - English',
    duration: 3 * 60 * 60,
    totalQuestions: 90,
    storagePath: 'PYQTestSeries/JeeMains/6 April 2023 (Shift1)',
    backLink: '/test-series/pyq/jeemains',
    answerKey: {1: "4", 2: "1", 3: "3", 4: "1", 5: "1", 6: "2", 7: "3", 8: "3", 9: "2", 10: "4",
    11: "2", 12: "2", 13: "3", 14: "4", 15: "4", 16: "2", 17: "1", 18: "3", 19: "3", 20: "3",
    21: "25", 22: "2", 23: "176", 24: "25", 25: "420", 26: "3", 27: "628", 28: "240", 29: "50", 30: "425",
    31: "2", 32: "3", 33: "4", 34: "4", 35: "3", 36: "1", 37: "2", 38: "1", 39: "3", 40: "2",
    41: "3", 42: "1", 43: "1", 44: "3", 45: "3", 46: "3", 47: "2", 48: "4", 49: "4", 50: "1",
    51: "1", 52: "7", 53: "3", 54: "10", 55: "2", 56: "9", 57: "1111", 58: "2", 59: "6", 60: "4",
    61: "2", 62: "1", 63: "3", 64: "4", 65: "4", 66: "3", 67: "4", 68: "1", 69: "3", 70: "1",
    71: "3", 72: "3", 73: "4", 74: "1", 75: "3", 76: "4", 77: "3", 78: "4", 79: "2", 80: "4",
    81: "171", 82: "5005", 83: "121", 84: "3", 85: "18", 86: "25", 87: "292", 88: "5", 89: "2", 90: "594",
}
  },
  '8april2023shift1': {
    id: '8april2023shift1',
    testName: 'JEE-Main 2023: 8 April 2023 (Shift1) - English',
    year: '2023',
    examName: 'JEE-Main 2023',
    subject: '8 April 2023 (Shift1) - English',
    duration: 3 * 60 * 60,
    totalQuestions: 90,
    storagePath: 'PYQTestSeries/JeeMains/8 April 2023 (Shift1)',
    backLink: '/test-series/pyq/jeemains',
    answerKey: {1: "4", 2: "2", 3: "3", 4: "1", 5: "1", 6: "4", 7: "1", 8: "3", 9: "4", 10: "4",
    11: "1", 12: "1", 13: "2", 14: "2", 15: "2", 16: "3", 17: "1", 18: "2", 19: "1", 20: "2",
    21: "125", 22: "1", 23: "10", 24: "900", 25: "18", 26: "25", 27: "2", 28: "9", 29: "18", 30: "121",
    31: "3", 32: "2", 33: "3", 34: "4", 35: "2", 36: "4", 37: "1", 38: "4", 39: "4", 40: "1",
    41: "2", 42: "3", 43: "3", 44: "3", 45: "3", 46: "2", 47: "2", 48: "4", 49: "4", 50: "3",
    51: "11", 52: "1", 53: "3", 54: "3", 55: "1200", 56: "2", 57: "70", 58: "82", 59: "2", 60: "11",
    61: "4", 62: "2", 63: "1", 64: "2", 65: "4", 66: "4", 67: "2", 68: "2", 69: "3", 70: "2",
    71: "3", 72: "2", 73: "2", 74: "1", 75: "1", 76: "3", 77: "1", 78: "4", 79: "2", 80: "1",
    81: "31", 82: "1275", 83: "2", 84: "25", 85: "19", 86: "5", 87: "14", 88: "3", 89: "11", 90: "9",
}
  },
  // 2024 Tests
  '27jan2024shift1': {
    id: '27jan2024shift1',
    testName: 'JEE-Main 2024: 27 Jan 2024 (Shift1) - English',
    year: '2024',
    examName: 'JEE-Main 2024',
    subject: '27 Jan 2024 (Shift1) - English',
    duration: 3 * 60 * 60,
    totalQuestions: 90,
    storagePath: 'PYQTestSeries/JeeMains/27 Jan 2024 (Shift1)',
    backLink: '/test-series/pyq/jeemains',
    answerKey: {1: "1", 2: "4", 3: "2", 4: "3", 5: "4", 6: "4", 7: "2", 8: "3", 9: "2", 10: "3",
    11: "1", 12: "3", 13: "3", 14: "3", 15: "2", 16: "1", 17: "4", 18: "2", 19: "4", 20: "2",
    21: "673", 22: "16", 23: "2", 24: "12", 25: "3", 26: "400", 27: "160", 28: "2", 29: "31", 30: "236",
    31: "1", 32: "4", 33: "4", 34: "4", 35: "1", 36: "2", 37: "2", 38: "4", 39: "4", 40: "4",
    41: "2", 42: "4", 43: "4", 44: "1", 45: "3", 46: "4", 47: "3", 48: "4", 49: "1", 50: "1",
    51: "8", 52: "16", 53: "6", 54: "1200", 55: "4", 56: "3", 57: "4", 58: "108", 59: "2", 60: "3",
    61: "1", 62: "3", 63: "1", 64: "1", 65: "4", 66: "3", 67: "3", 68: "1", 69: "2", 70: "2",
    71: "4", 72: "4", 73: "4", 74: "4", 75: "4", 76: "1", 77: "4", 78: "2", 79: "2", 80: "2",
    81: "5", 82: "9", 83: "48", 84: "28", 85: "202", 86: "2890", 87: "119", 88: "29", 89: "5",       90: "12"
}
  },
  '29jan2024shift1': {
    id: '29jan2024shift1',
    testName: 'JEE-Main 2024: 29 Jan 2024 (Shift1) - English',
    year: '2024',
    examName: 'JEE-Main 2024',
    subject: '29 Jan 2024 (Shift1) - English',
    duration: 3 * 60 * 60,
    totalQuestions: 90,
    storagePath: 'PYQTestSeries/JeeMains/29 Jan 2024 (Shift1)',
    backLink: '/test-series/pyq/jeemains',
    answerKey: {1: "1", 2: "2", 3: "1", 4: "3", 5: "3", 6: "4", 7: "3", 8: "4", 9: "1", 10: "2",
    11: "3", 12: "2", 13: "2", 14: "3", 15: "2", 16: "3", 17: "2", 18: "2", 19: "4", 20: "2",
    21: "2", 22: "10", 23: "810", 24: "9", 25: "8", 26: "81", 27: "6", 28: "2", 29: "2", 30: "17",
    31: "1", 32: "3", 33: "2", 34: "1", 35: "4", 36: "1", 37: "4", 38: "2", 39: "3", 40: "4",
    41: "4", 42: "3", 43: "1", 44: "1", 45: "1", 46: "4", 47: "1", 48: "3", 49: "2", 50: "4",
    51: "4", 52: "1", 53: "2", 54: "2", 55: "1", 56: "4", 57: "73", 58: "46", 59: "30", 60: "3",
    61: "2", 62: "2", 63: "4", 64: "3", 65: "2", 66: "2", 67: "3", 68: "1", 69: "2", 70: "4",
    71: "3", 72: "4", 73: "3", 74: "1", 75: "4", 76: "1", 77: "1", 78: "2", 79: "3", 80: "3",
    81: "13", 82: "553", 83: "2041", 84: "2", 85: "432", 86: "6344", 87: "5", 88: "171", 89: "3", 90: "65" 
}
  },
  '4april2024shift1': {
    id: '4april2024shift1',
    testName: 'JEE-Main 2024: 4 April 2024 (Shift1) - English',
    year: '2024',
    examName: 'JEE-Main 2024',
    subject: '4 April 2024 (Shift1) - English',
    duration: 3 * 60 * 60,
    totalQuestions: 90,
    storagePath: 'PYQTestSeries/JeeMains/4 April 2024 (Shift1)',
    backLink: '/test-series/pyq/jeemains',
    answerKey: {1: "3", 2: "1", 3: "1", 4: "1", 5: "4", 6: "1", 7: "4", 8: "2", 9: "3", 10: "3",
    11: "1", 12: "3", 13: "2", 14: "1", 15: "4", 16: "4", 17: "1", 18: "2", 19: "2", 20: "1",
    21: "6", 22: "7", 23: "5", 24: "7", 25: "16", 26: "1", 27: "50", 28: "8", 29: "9", 30: "7",
    31: "2", 32: "1", 33: "4", 34: "3", 35: "1", 36: "4", 37: "3", 38: "3", 39: "4", 40: "4",
    41: "4", 42: "1", 43: "4", 44: "1", 45: "2", 46: "4", 47: "1", 48: "1", 49: "4", 50: "1",
    51: "8", 52: "2", 53: "125", 54: "8", 55: "9", 56: "707", 57: "100", 58: "4", 59: "1", 60: "45",
    61: "2", 62: "4", 63: "3", 64: "1", 65: "1", 66: "3", 67: "2", 68: "1", 69: "2", 70: "2",
    71: "3", 72: "2", 73: "2", 74: "4", 75: "4", 76: "3", 77: "4", 78: "1", 79: "3", 80: "1",
    81: "8", 82: "72", 83: "233", 84: "100", 85: "45", 86: "27", 87: "8", 88: "7", 89: "54", 90: "48"
}
  },
  '5april2024shift1': {
    id: '5april2024shift1',
    testName: 'JEE-Main 2024: 5 April 2024 (Shift1) - English',
    year: '2024',
    examName: 'JEE-Main 2024',
    subject: '5 April 2024 (Shift1) - English',
    duration: 3 * 60 * 60,
    totalQuestions: 90,
    storagePath: 'PYQTestSeries/JeeMains/5 April 2024 (Shift1)',
    backLink: '/test-series/pyq/jeemains',
    answerKey: {1: "2", 2: "3", 3: "4", 4: "2", 5: "4", 6: "4", 7: "4", 8: "1", 9: "2", 10: "3",
    11: "2", 12: "2", 13: "2", 14: "1", 15: "4", 16: "2", 17: "2", 18: "4", 19: "2", 20: "3",
    21: "19", 22: "240", 23: "600", 24: "86", 25: "4", 26: "5", 27: "5", 28: "50", 29: "10", 30: "727",
    31: "3", 32: "2", 33: "4", 34: "3", 35: "3", 36: "3", 37: "2", 38: "4", 39: "2", 40: "2",
    41: "1", 42: "2", 43: "3", 44: "2", 45: "3", 46: "2", 47: "3", 48: "1", 49: "4", 50: "2",
    51: "80", 52: "22", 53: "8", 54: "150", 55: "25", 56: "3", 57: "5", 58: "2", 59: "14", 60: "6",
    61: "1", 62: "2", 63: "3", 64: "2", 65: "2", 66: "3", 67: "1", 68: "4", 69: "3", 70: "2",
    71: "1", 72: "4", 73: "1", 74: "4", 75: "4", 76: "1", 77: "3", 78: "4", 79: "4", 80: "2",
    81: "125", 82: "910", 83: "54", 84: "108", 85: "24", 86: "56", 87: "3", 88: "18", 89: "72", 90: "30"
}
  },
  // 2025 Tests
  '22jan2025shift1': {
    id: '22jan2025shift1',
    testName: 'JEE-Main 2025: 22 Jan 2025 (Shift1) - English',
    year: '2025',
    examName: 'JEE-Main 2025',
    subject: '22 Jan 2025 (Shift1) - English',
    duration: 3 * 60 * 60,
    totalQuestions: 90,
    storagePath: 'PYQTestSeries/JeeMains/22 Jan 2025 (Shift1)',
    backLink: '/test-series/pyq/jeemains',
    answerKey: {1: "4", 2: "3", 3: "2", 4: "1", 5: "4", 6: "2", 7: "3", 8: "1", 9: "1", 10: "1",
    11: "2", 12: "1", 13: "2", 14: "4", 15: "2", 16: "4", 17: "2", 18: "2", 19: "2", 20: "2",
    21: "34", 22: "2035", 23: "16", 24: "34", 25: "216", 26: "3", 27: "2", 28: "4", 29: "1", 30: "4",
    31: "2", 32: "4", 33: "4", 34: "4", 35: "1", 36: "4", 37: "3", 38: "4", 39: "3", 40: "3",
    41: "2", 42: "4", 43: "2", 44: "1", 45: "4", 46: "8", 47: "4", 48: "90", 49: "40", 50: "5",
    51: "2", 52: "2", 53: "3", 54: "4", 55: "3", 56: "3", 57: "2", 58: "4", 59: "2", 60: "2",
    61: "1", 62: "1", 63: "3", 64: "3", 65: "1", 66: "2", 67: "3", 68: "4", 69: "4", 70: "3",
    71: "6", 72: "69", 73: "154", 74: "45", 75: "20"
}
  },
  '23jan2025shift1': {
    id: '23jan2025shift1',
    testName: 'JEE-Main 2025: 23 Jan 2025 (Shift1) - English',
    year: '2025',
    examName: 'JEE-Main 2025',
    subject: '23 Jan 2025 (Shift1) - English',
    duration: 3 * 60 * 60,
    totalQuestions: 90,
    storagePath: 'PYQTestSeries/JeeMains/23 Jan 2025 (Shift1)',
    backLink: '/test-series/pyq/jeemains',
    answerKey: {1: "1", 2: "2", 3: "4", 4: "4", 5: "3", 6: "3", 7: "4", 8: "2", 9: "4", 10: "2",
    11: "4", 12: "4", 13: "1", 14: "2", 15: "4", 16: "3", 17: "2", 18: "2", 19: "2", 20: "3",
    21: "19", 22: "117", 23: "30", 24: "612", 25: "77", 26: "4", 27: "1", 28: "1", 29: "1", 30: "1",
    31: "1", 32: "3", 33: "4", 34: "4", 35: "4", 36: "1", 37: "3", 38: "1", 39: "2", 40: "4",
    41: "2", 42: "3", 43: "1", 44: "4", 45: "1", 46: "5", 47: "3", 48: "3", 49: "273", 50: "152",
    51: "1", 52: "3", 53: "2", 54: "4", 55: "2", 56: "4", 57: "2", 58: "2", 59: "1", 60: "4",
    61: "1", 62: "3", 63: "1", 64: "2", 65: "2", 66: "3", 67: "4", 68: "3", 69: "3", 70: "1",
    71: "2850", 72: "897", 73: "40", 74: "7", 75: "171"
}
  },
  // 2019 Tests
  '9jan2019shift1': {
    id: '9jan2019shift1',
    testName: 'JEE-Main 2019: 9 Jan 2019 (Shift1) - English',
    year: '2019',
    examName: 'JEE-Main 2019',
    subject: '9 Jan 2019 (Shift1) - English',
    duration: 3 * 60 * 60,
    totalQuestions: 90,
    storagePath: 'PYQTestSeries/JeeMains/9 Jan 2019 (Shift1)',
    backLink: '/test-series/pyq/jeemains',
    answerKey: { 1: "4", 2: "2", 3: "4", 4: "1", 5: "2", 6: "4", 7: "2", 8: "3", 9: "3", 10: "3",
    11: "1", 12: "3", 13: "4", 14: "3", 15: "1", 16: "2", 17: "2", 18: "4", 19: "4", 20: "1",
    21: "2", 22: "4", 23: "1", 24: "1", 25: "1", 26: "2", 27: "1", 28: "1", 29: "2", 30: "4",
    31: "3", 32: "2", 33: "4", 34: "3", 35: "3", 36: "4", 37: "4", 38: "1", 39: "1", 40: "3",
    41: "1", 42: "1", 43: "2", 44: "3", 45: "2", 46: "2", 47: "3", 48: "4", 49: "2", 50: "4",
    51: "4", 52: "2", 53: "3", 54: "4", 55: "1", 56: "4", 57: "2", 58: "4", 59: "4", 60: "4",
    61: "4", 62: "3", 63: "1", 64: "2", 65: "1", 66: "3", 67: "3", 68: "2", 69: "1", 70: "3",
    71: "2", 72: "1", 73: "2", 74: "4", 75: "4", 76: "1", 77: "1", 78: "4", 79: "1", 80: "3",
    81: "1", 82: "4", 83: "4", 84: "3", 85: "2", 86: "4", 87: "1", 88: "3", 89: "1", 90: "4",
}
  },
  '10jan2019shift1': {
    id: '10jan2019shift1',
    testName: 'JEE-Main 2019: 10 Jan 2019 (Shift1) - English',
    year: '2019',
    examName: 'JEE-Main 2019',
    subject: '10 Jan 2019 (Shift1) - English',
    duration: 3 * 60 * 60,
    totalQuestions: 90,
    storagePath: 'PYQTestSeries/JeeMains/10 Jan 2019 (Shift1)',
    backLink: '/test-series/pyq/jeemains',
    answerKey: {1: "3", 2: "3", 3: "1", 4: "4", 5: "1", 6: "1", 7: "3", 8: "2", 9: "1", 10: "3",
    11: "3", 12: "3", 13: "1", 14: "2", 15: "4", 16: "4", 17: "3", 18: "4", 19: "3", 20: "2",
    21: "1", 22: "1", 23: "1", 24: "4", 25: "3", 26: "2", 27: "2", 28: "4", 29: "4", 30: "4",
    31: "1", 32: "1", 33: "2", 34: "2", 35: "3", 36: "3", 37: "1", 38: "3", 39: "3", 40: "1",
    41: "1", 42: "3", 43: "3", 44: "4", 45: "2", 46: "3", 47: "3", 48: "3", 49: "4", 50: "1",
    51: "2", 52: "4", 53: "1", 54: "2", 55: "1", 56: "1", 57: "2", 58: "4", 59: "3", 60: "1",
    61: "1", 62: "3", 63: "4", 64: "1", 65: "2", 66: "4", 67: "1", 68: "4", 69: "1", 70: "2",
    71: "4", 72: "3", 73: "1", 74: "3", 75: "2", 76: "2", 77: "3", 78: "1", 79: "3", 80: "1",
    81: "4", 82: "4", 83: "3", 84: "4", 85: "2", 86: "3", 87: "1", 88: "2", 89: "4", 90: "2",
}
  },
  '8april2019shift1': {
    id: '8april2019shift1',
    testName: 'JEE-Main 2019: 8 April 2019 (Shift1) - English',
    year: '2019',
    examName: 'JEE-Main 2019',
    subject: '8 April 2019 (Shift1) - English',
    duration: 3 * 60 * 60,
    totalQuestions: 90,
    storagePath: 'PYQTestSeries/JeeMains/8 April 2019 (Shift1)',
    backLink: '/test-series/pyq/jeemains',
    answerKey: {1: "3", 2: "2", 3: "3", 4: "1", 5: "2", 6: "3", 7: "4", 8: "1", 9: "4", 10: "2",
    11: "2", 12: "2", 13: "4", 14: "3", 15: "3", 16: "2", 17: "1", 18: "4", 19: "1", 20: "2",
    21: "2", 22: "4", 23: "1", 24: "2", 25: "3", 26: "1", 27: "4", 28: "2", 29: "1", 30: "4",
    31: "2", 32: "1", 33: "4", 34: "2", 35: "2", 36: "2", 37: "2", 38: "4", 39: "3", 40: "4",
    41: "4", 42: "1", 43: "2", 44: "1", 45: "1", 46: "2", 47: "4", 48: "4", 49: "3", 50: "4",
    51: "4", 52: "1", 53: "4", 54: "4", 55: "1", 56: "1", 57: "2", 58: "3", 59: "4", 60: "1",
    61: "1", 62: "2", 63: "3", 64: "3", 65: "3", 66: "2", 67: "4", 68: "1", 69: "1", 70: "4",
    71: "1", 72: "1", 73: "4", 74: "1", 75: "3", 76: "3", 77: "3", 78: "4", 79: "4", 80: "1",
    81: "4", 82: "4", 83: "1", 84: "3", 85: "4", 86: "1", 87: "2", 88: "1", 89: "3", 90: "1",
}
  },
  '9april2019shift1': {
    id: '9april2019shift1',
    testName: 'JEE-Main 2019: 9 April 2019 (Shift1) - English',
    year: '2019',
    examName: 'JEE-Main 2019',
    subject: '9 April 2019 (Shift1) - English',
    duration: 3 * 60 * 60,
    totalQuestions: 90,
    storagePath: 'PYQTestSeries/JeeMains/9 April 2019 (Shift1)',
    backLink: '/test-series/pyq/jeemains',
    answerKey: {1: "1", 2: "3", 3: "3", 4: "1", 5: "2", 6: "1", 7: "2", 8: "2", 9: "2", 10: "3",
    11: "4", 12: "3", 13: "3", 14: "4", 15: "3", 16: "1", 17: "4", 18: "2", 19: "4", 20: "3",
    21: "2", 22: "4", 23: "3", 24: "4", 25: "3", 26: "2", 27: "4", 28: "2", 29: "2", 30: "4",
    31: "3", 32: "4", 33: "2", 34: "2", 35: "1", 36: "1", 37: "1", 38: "4", 39: "2", 40: "4",
    41: "1", 42: "4", 43: "1", 44: "4", 45: "1", 46: "4", 47: "3", 48: "1", 49: "1", 50: "4",
    51: "1", 52: "3", 53: "4", 54: "3", 55: "2", 56: "3", 57: "2", 58: "2", 59: "1", 60: "3",
    61: "3", 62: "3", 63: "3", 64: "4", 65: "4", 66: "1", 67: "4", 68: "2", 69: "2", 70: "2",
    71: "4", 72: "3", 73: "4", 74: "4", 75: "1", 76: "3", 77: "1", 78: "1", 79: "1", 80: "3",
    81: "1", 82: "2", 83: "3", 84: "3", 85: "3", 86: "3", 87: "1", 88: "2", 89: "2", 90: "4",
}
  },
  // 2018 Tests
  '15april2018shift1': {
    id: '15april2018shift1',
    testName: 'JEE-Main 2018: 15 April 2018 (Shift1) - English',
    year: '2018',
    examName: 'JEE-Main 2018',
    subject: '15 April 2018 (Shift1) - English',
    duration: 3 * 60 * 60,
    totalQuestions: 90,
    storagePath: 'PYQTestSeries/JeeMains/15 April 2018 (Shift1)',
    backLink: '/test-series/pyq/jeemains',
    answerKey: {1: "3", 2: "2", 3: "3", 4: "2", 5: "1", 6: "3", 7: "3", 8: "1", 9: "1", 10: "1",
    11: "4", 12: "4", 13: "1", 14: "2", 15: "4", 16: "1", 17: "2", 18: "2", 19: "2", 20: "1",
    21: "1", 22: "2", 23: "3", 24: "1", 25: "3", 26: "2", 27: "4", 28: "4", 29: "2", 30: "4",
    31: "4", 32: "3", 33: "3", 34: "4", 35: "4", 36: "1", 37: "2", 38: "1", 39: "2", 40: "2",
    41: "2", 42: "4", 43: "4", 44: "4", 45: "3", 46: "4", 47: "1", 48: "3", 49: "1", 50: "4",
    51: "4", 52: "2", 53: "2", 54: "3", 55: "3", 56: "1", 57: "4", 58: "2", 59: "2", 60: "1",
    61: "2", 62: "1", 63: "4", 64: "3", 65: "1", 66: "4", 67: "2", 68: "2", 69: "3", 70: "3",
    71: "2", 72: "4", 73: "2", 74: "2", 75: "4", 76: "1", 77: "4", 78: "1", 79: "2", 80: "1",
    81: "1", 82: "1", 83: "2", 84: "3", 85: "2", 86: "1", 87: "2", 88: "3", 89: "4", 90: "1",
}
  },
  '15april2018shift2': {
    id: '15april2018shift2',
    testName: 'JEE-Main 2018: 15 April 2018 (Shift2) - English',
    year: '2018',
    examName: 'JEE-Main 2018',
    subject: '15 April 2018 (Shift2) - English',
    duration: 3 * 60 * 60,
    totalQuestions: 90,
    storagePath: 'PYQTestSeries/JeeMains/15 April 2018 (Shift2)',
    backLink: '/test-series/pyq/jeemains',
    answerKey: {1: "2", 2: "1", 3: "4", 4: "2", 5: "4", 6: "4", 7: "1", 8: "1", 9: "4", 10: "1",
    11: "4", 12: "4", 13: "3", 14: "1", 15: "4", 16: "3", 17: "3", 18: "1", 19: "1", 20: "1",
    21: "2", 22: "3", 23: "1", 24: "1", 25: "1", 26: "3", 27: "4", 28: "3", 29: "3", 30: "3",
    31: "3", 32: "2", 33: "4", 34: "4", 35: "3", 36: "2", 37: "1", 38: "2", 39: "2", 40: "2",
    41: "3", 42: "2", 43: "2", 44: "4", 45: "1", 46: "1", 47: "4", 48: "1", 49: "3", 50: "2",
    51: "4", 52: "1", 53: "3", 54: "4", 55: "2", 56: "2", 57: "1", 58: "2", 59: "2", 60: "1",
    61: "2", 62: "4", 63: "2", 64: "4", 65: "1", 66: "4", 67: "1", 68: "4", 69: "4", 70: "1",
    71: "1", 72: "3", 73: "4", 74: "4", 75: "4", 76: "1", 77: "4", 78: "4", 79: "3", 80: "1",
    81: "4", 82: "4", 83: "1", 84: "1", 85: "4", 86: "2", 87: "2", 88: "2", 89: "1", 90: "1",
}
  },
  // 2017 Tests
  '8april2017': {
    id: '8april2017',
    testName: 'JEE-Main 2017: 8 April 2017 - English',
    year: '2017',
    examName: 'JEE-Main 2017',
    subject: '8 April 2017 - English',
    duration: 3 * 60 * 60,
    totalQuestions: 90,
    storagePath: 'PYQTestSeries/JeeMains/8 April 2017',
    backLink: '/test-series/pyq/jeemains',
    answerKey: {1: "1", 2: "3", 3: "1", 4: "4", 5: "2", 6: "2", 7: "1", 8: "2", 9: "1", 10: "2",
    11: "1", 12: "4", 13: "4", 14: "2", 15: "4", 16: "2", 17: "4", 18: "4", 19: "2", 20: "4",
    21: "4", 22: "3", 23: "1", 24: "4", 25: "1", 26: "4", 27: "1", 28: "3", 29: "2", 30: "3",
    31: "2", 32: "2", 33: "4", 34: "3", 35: "2", 36: "4", 37: "3", 38: "1", 39: "1", 40: "3",
    41: "1", 42: "4", 43: "3", 44: "1", 45: "1", 46: "3", 47: "4", 48: "4", 49: "1", 50: "1",
    51: "2", 52: "2", 53: "2", 54: "1", 55: "1", 56: "1", 57: "3", 58: "2", 59: "2", 60: "1",
    61: "1", 62: "1", 63: "3", 64: "4", 65: "2", 66: "3", 67: "1", 68: "1", 69: "4", 70: "3",
    71: "3", 72: "1", 73: "1", 74: "1", 75: "2", 76: "2", 77: "2", 78: "1", 79: "2", 80: "3",
    81: "1", 82: "1", 83: "4", 84: "1", 85: "2", 86: "2", 87: "3", 88: "3", 89: "1", 90: "2",
}
  },
  '9april2017': {
    id: '9april2017',
    testName: 'JEE-Main 2017: 9 April 2017 - English',
    year: '2017',
    examName: 'JEE-Main 2017',
    subject: '9 April 2017 - English',
    duration: 3 * 60 * 60,
    totalQuestions: 90,
    storagePath: 'PYQTestSeries/JeeMains/9 April 2017',
    backLink: '/test-series/pyq/jeemains',
    answerKey: {1: "4", 2: "4", 3: "3", 4: "3", 5: "4", 6: "2", 7: "1", 8: "4", 9: "4", 10: "2",
    11: "4", 12: "4", 13: "2", 14: "3", 15: "4", 16: "2", 17: "4", 18: "3", 19: "1", 20: "1",
    21: "3", 22: "2", 23: "1", 24: "4", 25: "1", 26: "3", 27: "4", 28: "3", 29: "3", 30: "4",
    31: "1", 32: "2", 33: "3", 34: "2", 35: "3", 36: "4", 37: "2", 38: "1", 39: "2", 40: "3",
    41: "2", 42: "1", 43: "3", 44: "3", 45: "1", 46: "3", 47: "3", 48: "3", 49: "3", 50: "3",
    51: "1", 52: "2", 53: "2", 54: "4", 55: "3", 56: "1", 57: "1", 58: "1", 59: "2", 60: "1",
    61: "3", 62: "3", 63: "2", 64: "2", 65: "2", 66: "3", 67: "4", 68: "1", 69: "3", 70: "2",
    71: "1", 72: "4", 73: "3", 74: "1", 75: "3", 76: "1", 77: "3", 78: "4", 79: "2", 80: "2",
    81: "2", 82: "4", 83: "3", 84: "2", 85: "3", 86: "1", 87: "4", 88: "1", 89: "3", 90: "1",
}
  },
  // 2016 Tests
  '9april2016': {
    id: '9april2016',
    testName: 'JEE-Main 2016: 9 April 2016 - English',
    year: '2016',
    examName: 'JEE-Main 2016',
    subject: '9 April 2016 - English',
    duration: 3 * 60 * 60,
    totalQuestions: 90,
    storagePath: 'PYQTestSeries/JeeMains/9 April 2016',
    backLink: '/test-series/pyq/jeemains',
    answerKey: {1: "2", 2: "2", 3: "3", 4: "3", 5: "2", 6: "3", 7: "3", 8: "1", 9: "3", 10: "1",
    11: "4", 12: "4", 13: "4", 14: "2", 15: "4", 16: "1", 17: "1", 18: "4", 19: "2", 20: "4",
    21: "3", 22: "1", 23: "1", 24: "3", 25: "4", 26: "2", 27: "2", 28: "2", 29: "1", 30: "1",
    31: "3", 32: "4", 33: "2", 34: "4", 35: "1", 36: "1", 37: "3", 38: "4", 39: "2", 40: "1",
    41: "1", 42: "2", 43: "4", 44: "4", 45: "4", 46: "3", 47: "1", 48: "4", 49: "1", 50: "3",
    51: "3", 52: "2", 53: "4", 54: "3", 55: "1", 56: "3", 57: "4", 58: "2", 59: "4", 60: "2",
    61: "3", 62: "1", 63: "2", 64: "2", 65: "4", 66: "1", 67: "2", 68: "4", 69: "1", 70: "4",
    71: "1", 72: "3", 73: "1", 74: "4", 75: "2", 76: "1", 77: "1", 78: "3", 79: "3", 80: "3",
    81: "1", 82: "1", 83: "4", 84: "1", 85: "2", 86: "1", 87: "4", 88: "2", 89: "3", 90: "2",
}
  },
  '10april2016': {
    id: '10april2016',
    testName: 'JEE-Main 2016: 10 April 2016 - English',
    year: '2016',
    examName: 'JEE-Main 2016',
    subject: '10 April 2016 - English',
    duration: 3 * 60 * 60,
    totalQuestions: 90,
    storagePath: 'PYQTestSeries/JeeMains/10 April 2016',
    backLink: '/test-series/pyq/jeemains',
    answerKey: {1: "1", 2: "4", 3: "1", 4: "1", 5: "3", 6: "2", 7: "3", 8: "3", 9: "4", 10: "4",
    11: "4", 12: "2", 13: "4", 14: "3", 15: "1", 16: "1", 17: "1", 18: "4", 19: "2", 20: "2",
    21: "4", 22: "3", 23: "2", 24: "1", 25: "1", 26: "1", 27: "1", 28: "3", 29: "2", 30: "2",
    31: "1", 32: "2", 33: "2", 34: "1", 35: "1", 36: "1", 37: "3", 38: "1", 39: "1", 40: "1",
    41: "3", 42: "4", 43: "2", 44: "1", 45: "1", 46: "3", 47: "4", 48: "1", 49: "3", 50: "1",
    51: "3", 52: "1", 53: "3", 54: "1", 55: "4", 56: "1", 57: "1", 58: "4", 59: "1", 60: "3",
    61: "1", 62: "2", 63: "3", 64: "1", 65: "2", 66: "2", 67: "2", 68: "3", 69: "3", 70: "3",
    71: "1", 72: "1", 73: "3", 74: "3", 75: "3", 76: "3", 77: "4", 78: "1", 79: "4", 80: "3",
    81: "1", 82: "3", 83: "3", 84: "4", 85: "4", 86: "4", 87: "3", 88: "2", 89: "3", 90: "4",
}
  },
  // 2015 Tests
  '10april2015': {
    id: '10april2015',
    testName: 'JEE-Main 2015: 10 April 2015 - English',
    year: '2015',
    examName: 'JEE-Main 2015',
    subject: '10 April 2015 - English',
    duration: 3 * 60 * 60,
    totalQuestions: 90,
    storagePath: 'PYQTestSeries/JeeMains/10 April 2015',
    backLink: '/test-series/pyq/jeemains',
    answerKey: {1: "1", 2: "4", 3: "1", 4: "4", 5: "4", 6: "1", 7: "2", 8: "4", 9: "1", 10: "1",
    11: "3", 12: "3", 13: "3", 14: "4", 15: "4", 16: "1", 17: "2", 18: "2", 19: "3", 20: "2",
    21: "2", 22: "1", 23: "4", 24: "4", 25: "3", 26: "1", 27: "3", 28: "2", 29: "3", 30: "3",
    31: "4", 32: "4", 33: "1", 34: "2", 35: "4", 36: "3", 37: "4", 38: "1", 39: "4", 40: "2",
    41: "4", 42: "2", 43: "2", 44: "3", 45: "3", 46: "2", 47: "1", 48: "4", 49: "1", 50: "2",
    51: "1", 52: "1", 53: "2", 54: "4", 55: "1", 56: "4", 57: "3", 58: "1", 59: "4", 60: "4",
    61: "4", 62: "1", 63: "2", 64: "3", 65: "2", 66: "4", 67: "1", 68: "2", 69: "3", 70: "2",
    71: "1", 72: "2", 73: "2", 74: "2", 75: "1", 76: "2", 77: "3", 78: "3", 79: "3", 80: "3",
    81: "3", 82: "4", 83: "2", 84: "1", 85: "4", 86: "3", 87: "4", 88: "3", 89: "2", 90: "2",
}
  },
  '11april2015': {
    id: '11april2015',
    testName: 'JEE-Main 2015: 11 April 2015 - English',
    year: '2015',
    examName: 'JEE-Main 2015',
    subject: '11 April 2015 - English',
    duration: 3 * 60 * 60,
    totalQuestions: 90,
    storagePath: 'PYQTestSeries/JeeMains/11 April 2015',
    backLink: '/test-series/pyq/jeemains',
    answerKey: {1: "3", 2: "1", 3: "4", 4: "4", 5: "2", 6: "1", 7: "1", 8: "1", 9: "3", 10: "2",
    11: "4", 12: "3", 13: "3", 14: "1", 15: "1", 16: "1", 17: "3", 18: "1", 19: "4", 20: "1",
    21: "4", 22: "3", 23: "1", 24: "2", 25: "1", 26: "1", 27: "4", 28: "2", 29: "3", 30: "4",
    31: "4", 32: "4", 33: "4", 34: "1", 35: "2", 36: "3", 37: "4", 38: "3", 39: "4", 40: "1",
    41: "2", 42: "2", 43: "1", 44: "2", 45: "2", 46: "2", 47: "1", 48: "3", 49: "3", 50: "4",
    51: "4", 52: "2", 53: "3", 54: "4", 55: "4", 56: "1", 57: "1", 58: "3", 59: "1", 60: "4",
    61: "2", 62: "2", 63: "2", 64: "3", 65: "1", 66: "1", 67: "1", 68: "4", 69: "2", 70: "4",
    71: "4", 72: "4", 73: "3", 74: "2", 75: "3", 76: "2", 77: "3", 78: "2", 79: "3", 80: "4",
    81: "1", 82: "3", 83: "1", 84: "2", 85: "2", 86: "4", 87: "2", 88: "2", 89: "4", 90: "1",
}
  }
};


// ✅ HELPER FUNCTION: Get subject for JEE Mains based on question number
// Pattern: first 1/3 = Physics, second 1/3 = Chemistry, last 1/3 = Mathematics
export function getJEESubject(questionId, totalQuestions) {
  if (totalQuestions === 75) {
    // Physics: 1-25, Chemistry: 26-50, Mathematics: 51-75
    if (questionId >= 1 && questionId <= 25) return 'Physics';
    if (questionId >= 26 && questionId <= 50) return 'Chemistry';
    return 'Mathematics';
  } else if (totalQuestions === 90) {
    // Physics: 1-30, Chemistry: 31-60, Mathematics: 61-90
    if (questionId >= 1 && questionId <= 30) return 'Physics';
    if (questionId >= 31 && questionId <= 60) return 'Chemistry';
    return 'Mathematics';
  }
  // Fallback: divide equally
  const third = Math.ceil(totalQuestions / 3);
  if (questionId <= third) return 'Physics';
  if (questionId <= third * 2) return 'Chemistry';
  return 'Mathematics';
}

// ✅ HELPER FUNCTION: Determine question type based on JEE Mains pattern
export function getJEEQuestionType(questionId, totalQuestions) {
  if (totalQuestions === 75) {
    // 75-question pattern (2020-2021)
    // Physics: 1-20 MCQ, 21-25 Numerical
    // Chemistry: 26-45 MCQ, 46-50 Numerical
    // Maths: 51-70 MCQ, 71-75 Numerical
    if ((questionId >= 1 && questionId <= 20) ||
        (questionId >= 26 && questionId <= 45) ||
        (questionId >= 51 && questionId <= 70)) {
      return "mcq";
    }
    return "numerical";
  } else if (totalQuestions === 90) {
    // 90-question pattern (2022+)
    // Physics: 1-20 MCQ, 21-30 Numerical
    // Chemistry: 31-50 MCQ, 51-60 Numerical
    // Maths: 61-80 MCQ, 81-90 Numerical
    if ((questionId >= 1 && questionId <= 20) ||
        (questionId >= 31 && questionId <= 50) ||
        (questionId >= 61 && questionId <= 80)) {
      return "mcq";
    }
    return "numerical";
  }
  
  // Default fallback
  return "mcq";
}
